module.exports = __webpack_public_path__ + "static/img/up.3709f6ac.svg";